<template>
  <div id="newsletter">
    <router-link to="/"><div id="newsletter-form-close" class="close"></div></router-link>
    <div id="newsletter-form" class="center">
      <p class="center mx4">Subscribe to the Bar Laika Newsletter</p>
      <form method="post" action="https://interspire.e-flux.com/form.php?form=21" id="frmSS21" @submit="checkForm">
        <input type="text" name="email" v-model="email" value="" placeholder="E-Mail Address" autofocus />
        <input type="hidden" name="format" value="h" />
        <input type="submit" value="Subscribe" />
      </form>
      <div v-if="errors.length">
        <p v-for="(error, index) in errors" :key="index">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'Newsletter',

  data () {
    return {
      email: null,
      errors: []
    }
  },
  methods: {
    closeNewsletterForm: function () {
      this.$emit('close')
    },
    checkForm: function (e) {
      this.errors = []
      if (!this.email) {
        this.errors.push('Email required')
      } else if (!this.validEmail(this.email)) {
        this.errors.push('Valid email required')
      }
      if (!this.errors.length) return true
      e.preventDefault()
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  }
}
</script>

<style lang="css" scoped>
  #newsletter-form-close {
    position: fixed;
    top: 0.6em;
    left: 0.6em;
  }

  #newsletter {
    background: var(--color-red);
    color: var(--color-yellow);
    z-index: 9999;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
  }

  #newsletter-form {
    width: 100%;
  }

  input, input:-webkit-autofill {
    background: none;
    border: 3px solid var(--color-yellow);
    font-size: 1em;
    color: var(--color-yellow);
    padding: 0.25em;

    &:focus {
      outline: none;
    }

    &[type="submit"] {
      border-left: none;
      &:hover {
        background: var(--color-yellow);
        color: var(--color-red);
        cursor: pointer;
      }
    }

    &::placeholder {
      color: rgba(255,255,0,0.4);
    }
  }

  .close {
    position: absolute;;
    width: 48px;
    height: 48px;
    cursor: pointer;
    transition: 0.1s ease-in-out;

    &:hover {
      transform: scale(1.1);
    }
  }
  .close:before, .close:after {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 48px;
    width: 3px;
    background-color: var(--color-yellow);
  }
  .close:before {
    transform: rotate(45deg);
  }
  .close:after {
    transform: rotate(-45deg);
  }
</style>
